import {routineForChildren, routineForComponent} from '@im-ng/route';

export const TECHNOLOGIES_SLUG   = 'technologies';
export const TECHNOLOGIES_IOT_PLATFORM_SLUG = 'iot-platform';
export const TECHNOLOGIES_BIG_DATA_SLUG = 'big-data';
export const TECHNOLOGIES_DEEP_LEARNING_SLUG = 'deep-learning';
export const TECHNOLOGIES_AR_SLUG = 'ar';



export const TECHNOLOGIES_IOT_PLATFORM_ROUTINE = routineForComponent(
	'TECHNOLOGIES_IOT_PLATFORM',
	[TECHNOLOGIES_SLUG, TECHNOLOGIES_IOT_PLATFORM_SLUG],
	{
		// icon: 'icon:iot-platform'
	}
);

export const TECHNOLOGIES_BIG_DATA_ROUTINE = routineForComponent(
	'TECHNOLOGIES_BIG_DATA',
	[TECHNOLOGIES_SLUG, TECHNOLOGIES_BIG_DATA_SLUG],
	{
		// icon: 'icon:bigdata'
	}
);

export const TECHNOLOGIES_DEEP_LEARNING_ROUTINE = routineForComponent(
	'TECHNOLOGIES_DEEP_LEARNING',
	[TECHNOLOGIES_SLUG, TECHNOLOGIES_DEEP_LEARNING_SLUG],
	{
		// icon: 'icon:deeplearning'
	}
);

export const TECHNOLOGIES_AR_ROUTINE = routineForComponent(
	'TECHNOLOGIES_AR',
	[TECHNOLOGIES_SLUG, TECHNOLOGIES_AR_SLUG],
	{
		// icon: 'icon:ar'
	}
);


export const TECHNOLOGIES_ROUTINE = routineForChildren(
	'TECHNOLOGIES',
	[TECHNOLOGIES_SLUG],
	{
		// icon: 'icon:production',
		children: [
			TECHNOLOGIES_IOT_PLATFORM_ROUTINE.menu,
			TECHNOLOGIES_BIG_DATA_ROUTINE.menu,
			TECHNOLOGIES_DEEP_LEARNING_ROUTINE.menu,
			TECHNOLOGIES_AR_ROUTINE.menu
		]
	}
);


